// extracted by mini-css-extract-plugin
export var animationContainer = "_ib-0";
export var asteriskIcon = "_ib-8";
export var conversationLeftSection = "_ib-4";
export var conversationListItem = "_ib-3";
export var conversationMiddleSection = "_ib-5";
export var conversationRightSection = "_ib-6";
export var detailsContent = "_ib-1";
export var listContainer = "_ib-7";
export var modalContent = "_ib-2";